import React, { useState } from 'react'
import { motion } from 'framer-motion'
import Section3Image from '../../assets/images/Section3.png'
import Section3PopUp1 from '../../assets/image/Modal (1).svg'
import Section3PopUp2 from '../../assets/image/Table cell.svg'
import Section3PopUp3 from '../../assets/image/Content.svg'
import '../../index.css'
import LandingPageModal from 'components/Modal'
import { Link } from 'react-router'

const Section3 = () => {
  const [, setIsMobileMenuOpen] = useState(false)
  const [modalData, setModalData] = useState({ isOpen: false, type: '' })

  const handleModalOpen = (type) => {
    setModalData({ isOpen: true, type })
    setIsMobileMenuOpen(false)
  }

  const handleModalClose = () => {
    setModalData({ isOpen: false, type: '' })
  }

  const fadeInUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
  }

  return (
    <>
      <motion.section
        className="Section3"
        variants={fadeInUpVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }} // 👈 ensures animation on scroll
      >
        <div className="Section3-container">
          {/* Right image container */}
          <motion.div
            className="relative overflow-visible flex justify-center"
            variants={fadeInUpVariant}
            transition={{ delay: 0.8 }}
          >
            <img
              src={Section3Image}
              alt="Section3-Image"
              className="w-[90%] max-w-[560px] h-auto"
            />

            <motion.img
              src={Section3PopUp1}
              alt="PopUp1-Image"
              className="absolute top-[-40px] left-6 w-20 h-[139.34px] sm:top-[-50px] sm:left-20 sm:w-28"
              initial={{ opacity: 0, scale: 0.8, y: 30 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: false }}
            />

            <motion.img
              src={Section3PopUp2}
              alt="PopUp2-Image"
              className="absolute top-[180px] right-[-40px] w-[200px] sm:top-[180px] sm:right-[-55px] sm:w-[300px] sm:h-[39.18px]"
              initial={{ opacity: 0, scale: 0.9, x: 60 }}
              whileInView={{ opacity: 1, scale: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.7 }}
              viewport={{ once: false }}
            />

            <motion.img
              src={Section3PopUp3}
              alt="PopUp3-Image"
              className="absolute top-[240px] left-2 h-[155.92] sm:top-[340px] sm:left-2 sm:w-28"
              initial={{ opacity: 0, scale: 0.8, y: 30 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              viewport={{ once: false }}
            />
          </motion.div>

          {/* Left content */}
          <motion.div
            variants={fadeInUpVariant}
            transition={{ delay: 0.4 }}
            viewport={{ once: false }}
          >
            <h2 className="font-roboto font-bold text-[40px] leading-[120%] tracking-normal">
              Become a Tutor
            </h2>
            <p className="font-roboto font-normal text-[18px] leading-[150%] text-justify mb-4">
              Share your blockchain expertise with eager learners and capitalize your knowledge with
              APOLO P2P! If you're an expert in blockchain basics, development, NFT, trading, DAO,
              smart contracts, or DeFi, APOLO P2P is the perfect platform to share your knowledge
              and grow your brand.Help students from all over the world achieve their goals while
              earning money on your own terms.
            </p>

            <h4 className="font-roboto font-bold text-[20px] leading-[140%] mt-6 mb-2">
              Global Student Reach
            </h4>
            <p className="font-roboto text-[18px] leading-[150%] mb-4 text-justify">
              Gain access to a worldwide audience of eager learners, expanding your network.
            </p>

            <h4 className="font-roboto font-bold text-[20px] leading-[140%] mt-6 mb-2">
              Flexible Schedules
            </h4>
            <p className="font-roboto text-[18px] leading-[150%] mb-4 text-justify">
              Teach when it suits you. Set your own availability and offer sessions that align with
              your lifestyle.
            </p>

            <h4 className="font-roboto font-bold text-[20px] leading-[140%] mt-6 mb-2">
              Scalable Earnings
            </h4>
            <p className="font-roboto text-[18px] leading-[150%] mb-4 text-justify">
              Maximize your income—the more you teach the more you earn. Our platform rewards active
              tutors with lower fees and higher visibility.
            </p>

            <Link to="/tutor/register">
              <button className="cta-button">Become a Tutor</button>
            </Link>
          </motion.div>
        </div>

        {modalData.isOpen && <LandingPageModal onClose={handleModalClose} type={modalData.type} />}
      </motion.section>
    </>
  )
}

export default Section3
